<div class="site-page-header-ghost-wrapper">
    <nz-page-header nzBackIcon [nzGhost]="false">
        <nz-page-header-title>Medicamentos</nz-page-header-title>
        <nz-page-header-subtitle class="hide-xs"> - Cadastro/edição de medicamentos.</nz-page-header-subtitle>
    </nz-page-header>

    <form nz-form [formGroup]="medicamentoForm" (ngSubmit)="onSubmit()" nzLayout="vertical">
        <div nz-row [nzGutter]="12">

            <div nz-col nzMd="5" nzXs="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Cod. de Barras:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="ean" autocomplete="off" mask="0000000000000" maxlength="45" formControlName="ean" placeholder="00000000000" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzMd="11" nzXs="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Descrição:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input nzHasFeedback maxlength="255" name="descricao" formControlName="descricao" placeholder="Descrição" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzMd="8" nzXs="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Laboratório:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select name="idlaboratorio" formControlName="idlaboratorio" nzShowSearch nzPlaceHolder="Seleciona o laboratório">
                            <nz-option *ngFor="let option of laboratorios" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzMd="8" nzXs="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Autorizador:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select name="idautorizador" formControlName="idautorizador" nzShowSearch nzPlaceHolder="Seleciona o autorizador">
                            <nz-option *ngFor="let option of autorizadores" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzMd="8" nzXs="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Programa:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select name="idprograma" formControlName="idprograma" nzShowSearch nzPlaceHolder="Seleciona o programa">
                            <nz-option *ngFor="let option of programas" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item style="padding-top:40px;">
                    <nz-form-control>
                        <label nz-checkbox name="controlado" formControlName="controlado">Medicamento Controlado</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="6">
                <nz-form-item>
                    <nz-form-label nzRequired>Telefone:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="telefone" mask="00000000000 || 0000000000" formControlName="telefone" placeholder="(xx) 00000-0000" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Site:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="site" maxlength="255" formControlName="site" placeholder="https://exemplo.com.br" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzMd="10" nzXs="24">
                <nz-form-item>
                    <nz-form-label>Observação:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input nzHasFeedback maxlength="255" name="observacao" formControlName="observacao" placeholder="Observação do medicamento" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzMd="24" nzXs="24">
                <nz-divider nzText="Descontos" nzOrientation="left"></nz-divider>
            </div>
            <div nz-col nzMd="24" nzXs="24" *ngFor="let control of listOfControl; let i = index">
                <div nz-row [nzGutter]="12">
                    <div nz-col nzMd="5" nzXs="24" nzOffset="5">

                        <nz-form-item>
                            <nz-form-label *ngIf="i == 0" [nzFor]="control.desconto">Desconto:</nz-form-label>
                            <nz-input-group nzAddOnAfter="%">
                                <nz-form-control>

                                    <input nz-input nzHasFeedback name="desconto" [attr.id]="control.id" [formControlName]="control.desconto" placeholder="0,00" />

                                </nz-form-control>
                            </nz-input-group>
                        </nz-form-item>

                    </div>
                    <div nz-col nzMd="9" nzXs="24">

                        <nz-form-item>
                            <nz-form-label *ngIf="i == 0" [nzFor]="control.obs_desconto">Observação do Desconto:</nz-form-label>

                            <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                                <input nz-input maxlength="255" name="obs_desconto" [attr.id]="control.id" [formControlName]="control.obs_desconto" placeholder="Observação de desconto" />
                            </nz-form-control>
                        </nz-form-item>

                    </div>

                </div>
            </div>
            <div nz-col nzSpan="14" nzOffset="5">
                <a nz-button nzBlock nzType="dashed" class="add-button" (click)="adicionarDesconto()">
                    <i nz-icon nzType="plus"></i> Mais Descontos
                </a>
            </div>
            <div nz-col nzSpan="24">
                <nz-divider></nz-divider>
            </div>

            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idmedicamento" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idmedicamento" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>